module.exports = __webpack_public_path__ + "static/privacy-min-78db675a76df9a924825e1d3da5567c8.jpg";